import {
  LIST_MAPPING_PATIENT_REQUEST,
  LIST_MAPPING_PATIENT_SUCCESS,
  LIST_MAPPING_PATIENT_FAIL,
  LIST_MAPPING_PATIENT_BY_PATIENT_ID_SUCCESS,
  LIST_MAPPING_PATIENT_BY_PATIENT_ID_REQUEST,
  LIST_MAPPING_PATIENT_BY_PATIENT_ID_FAIL,
  CREATE_MAPPING_PATIENT_REQUEST,
  CREATE_MAPPING_PATIENT_SUCCESS,
  CREATE_MAPPING_PATIENT_FAIL,
  DETAIL_MAPPING_PATIENT_REQUEST,
  DETAIL_MAPPING_PATIENT_SUCCESS,
  DETAIL_MAPPING_PATIENT_FAIL,
  UPDATE_MAPPING_PATIENT_REQUEST,
  UPDATE_MAPPING_PATIENT_SUCCESS,
  UPDATE_MAPPING_PATIENT_FAIL,
  DELETE_MAPPING_PATIENT_REQUEST,
  DELETE_MAPPING_PATIENT_SUCCESS,
  DELETE_MAPPING_PATIENT_FAIL,
  HISTORY_MAPPING_PATIENT_REQUEST,
  HISTORY_MAPPING_PATIENT_SUCCESS,
  HISTORY_MAPPING_PATIENT_FAIL
} from '../../constants/mapping-data'

const initialState = {
  listPatient: [],
  patientData: {},
  mappingList: [],
  loading: false,
  loadingCreate: false,
  loadingHistory: false,
  historyLog: [],
  error: null,
  pageable: {}
}

const mappingDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MAPPING_PATIENT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MAPPING_PATIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        listPatient: action.payload,
        pageable: action.pageable
      }
    case LIST_MAPPING_PATIENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_MAPPING_PATIENT_BY_PATIENT_ID_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MAPPING_PATIENT_BY_PATIENT_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        mappingList: action.payload,
        pageable: action.pageable
      }
    case LIST_MAPPING_PATIENT_BY_PATIENT_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_MAPPING_PATIENT_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_MAPPING_PATIENT_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        listPatient: [...state.listPatient, action.payload]
      }
    case CREATE_MAPPING_PATIENT_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case HISTORY_MAPPING_PATIENT_REQUEST:
      return {
        ...state,
        loadingHistory: true
      }
    case HISTORY_MAPPING_PATIENT_SUCCESS:
      return {
        ...state,
        loadingHistory: false,
        historyLog: action.payload
      }
    case HISTORY_MAPPING_PATIENT_FAIL:
      return {
        ...state,
        loadingHistory: false,
        error: action.payload
      }
    case DETAIL_MAPPING_PATIENT_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_MAPPING_PATIENT_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        branchType: action.payload
      }
    case DETAIL_MAPPING_PATIENT_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_MAPPING_PATIENT_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_MAPPING_PATIENT_SUCCESS:
      const branchType = action.payload
      const branchTypeId = action.branchTypeId
      const listPatientUpdate = [...state.listPatient]

      const index = listPatientUpdate.findIndex(
        (branchType) => branchType.id === branchTypeId
      )
      listPatientUpdate[index] = branchType

      return {
        ...state,
        loadingUpdate: false,
        listPatient: listPatientUpdate
      }
    case UPDATE_MAPPING_PATIENT_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_MAPPING_PATIENT_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_MAPPING_PATIENT_SUCCESS:
      const branchTypeIdDelete = action.payload
      const listPatientDelete = [...state.listPatient]

      const indexDelete = listPatientDelete.findIndex(
        (branchType) => branchType.id === branchTypeIdDelete
      )
      listPatientDelete.splice(indexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        listPatient: listPatientDelete
      }
    case DELETE_MAPPING_PATIENT_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default mappingDataReducer
